module.exports = __webpack_public_path__ + "static/media/layer-plus.877b70e2.svg";